module.exports = __webpack_public_path__ + "img/empty-check-circle.f44119b4.svg";